import { makeStyles } from '@material-ui/core'
import formatDate from 'src/utils/commonMethods/formatDate'
import { isMotorInsurance } from 'src/utils/commonMethods'
import datePic from 'src/assets/PolicyTile_Images/Group6.svg'
import datePicRed from 'src/assets/PolicyTile_Images/Group8.svg'
import { Button, Divider, Grid, Typography } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { DIGITALIZING } from 'src/utils/constants/Individual'

const PolicyDetailsCard = ({ activePolicy }) => {
  const classes = useStyles()
  const getTotalDays = (expiredTime) => {
    const expiredD = new Date(expiredTime)
    const presentD = new Date()
    let TotalDays = Math.round(
      (expiredD.getTime() - presentD.getTime()) / (1000 * 3600 * 24)
    )
    if (TotalDays <= 0) {
      TotalDays = 0
    }
    return TotalDays
  }

  const getExpiredButton = () => {
    if (activePolicy?.status !== DIGITALIZING) {
      const totaldays = getTotalDays(activePolicy?.expiresOn)
      if (totaldays === 0) {
        return (
          <Grid item className={classes.expiredButtonGridContainer}>
            <Button className={classes.expiredButton} disabled>
              Expired
            </Button>
          </Grid>
        )
      } else {
        return null
      }
    }
  }

  const getDateRange = () => {
    return (
      <>
        <img
          src={
            getTotalDays(activePolicy?.expiresOn) === 0 ? datePicRed : datePic
          }
          className={classes.dateImage}
          alt='Date'
        />
        <span className={classes.greySpan}>
          {formatDate(activePolicy?.issuedOn)}
        </span>
        <div className={classes.dateToSpan}>to</div>
        <div className={classes.greySpan}>
          {formatDate(activePolicy?.expiresOn)}
        </div>
      </>
    )
  }

  return (
    <>
      <div>
        <Grid container className={classes.gridContainer}>
          <Grid
            item
            className={classes.imageGridContainer}
            xs={6}
            md={4}
            lg={12 / 5}
          >
            <div className={classes.providerImageContainer}>
              <img
                src={activePolicy?.provider?.image}
                className='w-100 h-100'
                alt='Provider'
              />
            </div>
          </Grid>

          <Grid
            item
            className={classes.gridItemContainer}
            xs={6}
            md={4}
            lg={12 / 5}
          >
            {getExpiredButton()}
            <Grid item className={classes.gridItemTitle}>
              <Typography className={classes.title}>
                {getDateRange()}
              </Typography>
              <Divider className={classes.horizontalDivider} />
              <p className={classes.daysToExpireText}>
                {getTotalDays(activePolicy?.expiresOn)} Days to expire
              </p>
            </Grid>
          </Grid>

          <Grid
            item
            className={classes.gridItemContainer}
            xs={6}
            md={4}
            lg={12 / 5}
          >
            <Grid item className={classes.gridItemTitle}>
              <Typography className={classes.title}>Premium Paid</Typography>
            </Grid>
            <Grid item className={classes.gridItemValue}>
              <Typography className={classes.value}>
                {activePolicy?.premiumAmount !== null
                  ? formatToINR(activePolicy?.premiumAmount?.text)
                  : '-'}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            className={classes.gridItemContainer}
            xs={6}
            md={4}
            lg={12 / 5}
          >
            {isMotorInsurance(activePolicy?.insuranceType) ? (
              <>
                <Grid item className={classes.gridItemTitle}>
                  <Typography className={classes.title}>IDV</Typography>
                </Grid>

                <Grid item className={classes.gridItemValue}>
                  <Typography className={classes.value}>
                    {formatToINR(
                      activePolicy?.otherInformation?.vehicleIdv ?? '-'
                    )}
                  </Typography>
                </Grid>
              </>
            ) : (
              <>
                <Grid item className={classes.gridItemTitle}>
                  <Typography className={classes.title}>Sum Insured</Typography>
                </Grid>

                <Grid item className={classes.gridItemValue}>
                  <Typography className={classes.value}>
                    {formatToINR(activePolicy?.sumAssured?.text ?? '-')}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>

          <Grid
            item
            className={classes.gridItemContainer}
            xs={6}
            md={4}
            lg={12 / 5}
          >
            <Grid item className={classes.gridItemTitle}>
              <Typography className={classes.title}>Claims</Typography>
            </Grid>
            <Grid item className={classes.gridItemValue}>
              <Typography className={classes.value}>
                {activePolicy?.claimAmount !== null
                  ? formatToINR(activePolicy?.claimAmount?.text)
                  : '-'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default PolicyDetailsCard

const useStyles = makeStyles({
  daysToExpireText: {
    lineHeight: '0.9',
    fontSize: '12px',
    color: COLORS.GREY,
    textAlign: 'center',
    fontWeight: '600',
    marginTop: '4px',
    marginBottom: '0px',
    paddingTop: '3px',
  },
  value: {
    lineHeight: '0.9',
    fontSize: '12px',
    color: COLORS.GREY,
    textAlign: 'center',
    fontWeight: '600',
  },
  title: {
    lineHeight: '0.9',
    fontSize: '10px',
    color: 'rgba(51, 51, 51, 0.5)',
    fontWeight: '600',
    paddingBottom: '5px',
  },
  expiredButton: {
    color: `${COLORS.WHITE}!important`,
    minWidth: '30px',
    height: '13px',
    backgroundColor: `${COLORS.MEDIUM_PINK}!important`,
    borderRadius: '12px',
    textTransform: 'unset',
    size: 'small',
    fontSize: '10px',
    fontWeight: '500',
    padding: '10px !important',
  },
  expiredButtonGridContainer: {
    marginTop: '-10px',
    marginBottom: '-10px',
  },
  horizontalDivider: {
    width: '100%',
    margin: '0% 0% 0% 0%',
    backgroundColor: COLORS.DARK_GREY,
  },
  greySpan: {
    color: COLORS.GREY,
    fontSize: '13px',
    fontWeight: '500',
  },

  gridContainer: {
    backgroundColor: COLORS.WHITE,
    display: 'flex',
    padding: '24px 30px',
  },
  gridItemTitle: {
    marginLeft: '5px',
    paddingTop: '10px',
  },
  gridItemValue: {
    marginLeft: '5px',
  },
  dateToSpan: {
    padding: '0px 5px',
    color: COLORS.MEDIUM_LIGHTBLUE,
    fontSize: '13px',
  },
  dateImage: {
    width: '13px',
    paddingRight: '5px',
  },
  providerImageContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageGridContainer: {
    display: 'flex',
  },
  gridItemContainer: {
    width: '21%',
  },
})
